<template>
    <b-card class="mt-3" v-if="ready">
        <template v-slot:header>
            Email notification settings
            <span class="float-right" v-if="loading">
                <b-spinner label="Spinning" small></b-spinner>
            </span>
            <span class="float-right" v-else-if="!loading && lastUpdate">
                <strong>Last saved:</strong> {{ lastUpdate.fromNow() }}
            </span>
        </template>
        <b-card-text>
            <b-form>
                <b-form-group
                    label="Select for which events you want the user to be notified by email:"
                >
                    <b-form-checkbox-group
                        :disabled="loading"
                        v-model="selected"
                        :options="notificationTypes"
                        name="notification-types"
                        @change="updateNotificationSubscriptions"
                        stacked
                    ></b-form-checkbox-group>
                </b-form-group>
            </b-form>
        </b-card-text>
    </b-card>
</template>

<script>
import axios from "axios";
import _ from "lodash";
import moment from "moment";

export default {
  name: "NotificationManager",
  props: {
    userId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      ready: false,
      user: null,
      loading: false,
      selected: [],
      lastUpdate: null,
      types: []
    };
  },
  computed: {
    notificationTypes() {
      if (!this.types) {
        return [];
      }
      let types = [];

      Object.keys(this.types).forEach(i => {
        types.push({
          value: i,
          text: this.types[i]
        });
      });
      return types;
    }
  },
  mounted() {
    Promise.all([
      this.getNotificationSubscriptionTypes(),
      this.getUser()
    ]).finally(() => {
      this.ready = true;
    });
  },
  methods: {
    getNotificationSubscriptionTypes() {
      return new Promise(resolve => {
        axios
          .get("/api/notification-subscription-types")
          .then(response => {
            this.types = response.data;
          })
          .finally(() => {
            resolve();
          });
      });
    },
    getUser() {
      return new Promise(resolve => {
        axios
          .get("/api/users/" + this.userId)
          .then(response => {
            this.user = response.data.data;
            this.user.notification_subscriptions.forEach(s => {
              if (!this.types[s.notification]) {
                return;
              }

              this.selected.push(s.notification);
            });
          })
          .finally(() => {
            resolve();
          });
      });
    },
    updateNotificationSubscriptions: _.debounce(function() {
      this.loading = true;
      axios
        .post(
          "/api/users/" + this.userId + "/update-notification-subscriptions",
          {
            notifications: this.selected
          }
        )
        .finally(() => {
          (this.lastUpdate = moment()), (this.loading = false);
        });
    }, 750)
  }
};
</script>

<style scoped>
</style>
